<div class="modal-signup modal-content">
  <div>
    <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form document">
      <div class="card-header wh-header padding-bottom-0px padding-left-10px">
        <div class="row">
          <div class="col-md-6">
            <ul class="nav nav-tabs nav-tab-service2 margin-top-13px" id="tabContent">
              <li class="margin-right-15px"><a class="nav-itemerp active" href="#Material" data-toggle="tab">Edit Purchase Order Item</a></li>
            </ul>
          </div>
          <div class="col-md-6">
            <button type="button" class="close" data-dismiss="modal"
                    (click)="activeModal.dismiss('Cross click')"
                    aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </div>
        
      </div>
      <div class="modal-body padding-top-0px padding-bottom-0px">
        
        <div class="tab-content">          
          <div class="tab-pane active" id="Material">

            <form class="form" novalidate="" #fm="ngForm">

              <div class="card ">

                <div class="card-body margin-left-zero padding-top-0px padding-right-0px padding-bottom-0px">
                  <div class="row">
                    <div class="col-md-12 padding-l-0px">
                      <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12 my-profile-form padding-lr-0px">

                        <div class="card-body padding-bottom-0px padding-right-0px margin-left-0px padding-left-0px padding-top-0px">
                          <div class="row border-top border-bottom bk-color-lightgray margin-left-zero margin-right-0px">
                            <div class="col-md-4  text-align-center padding-right-0px padding-left-0px border-right-1px">
                              <div class="margin-top-10"><h4 class=" font-weight-bold margin-bottom-0px label-color-consultant font-size-12px">Material Name</h4></div>
                              <div class="margin-bottom-10px"><h4 class="margin-bottom-0px display-inline color-Checkin font-weight-bold">{{PurchaseOrderItem.ItemDescription}}</h4></div>
                            </div>
                            <div class="col-md-4  text-align-center padding-right-0px padding-left-0px border-right-1px">
                              <div class="margin-top-10"><h4 class="font-weight-bold margin-bottom-0px label-color-consultant font-size-12px">Store Location</h4></div>
                              <div class="margin-bottom-10px"><h4 class="margin-bottom-0px display-inline color-Assign">{{ShipToLocation}}</h4></div>
                            </div>
                            <div class="col-md-4 text-align-center padding-right-0px padding-left-0px border-right-1px">
                              <div class="margin-top-10"><h4 class=" font-weight-bold margin-bottom-0px label-color-consultant font-size-12px">Purchase Order#</h4></div>
                              <div class="margin-bottom-10px"><h4 class="margin-bottom-0px display-inline">{{PurchaseOrderCode}}</h4> </div>
                              
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-6">

                              <div class="row margin-top-10">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                  <div class="row">
                                    <div class="col-md-4 text-align-right padding-left-0px">
                                      <label for="firstName" class="margin-bottom-0px margin-top-2px">Supplier</label>
                                    </div>:
                                    <div class="col-md-5">
                                      <h4 class="margin-bottom-0px color-Assign margin-top-5px font-weight-bold">{{VendorName}}</h4>

                                    </div>

                                  </div>

                                </div>
                              </div>

                              <div class="row">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                  <div class="row">
                                    <div class="col-md-4 text-align-right padding-left-0px">
                                      <label for="firstName" class="margin-bottom-0px margin-top-5px">GST</label>
                                    </div>
                                    <div class="col-md-5">
                                      <CodeTypeValue CodeType="TAXPC" id="PurchaseOrderItem.TaxPercent"
                                                     [(ngModel)]="PurchaseOrderItem.TaxPercent" SelectedValue=""
                                                     name="PurchaseOrderItem.TaxPercent">
                                      </CodeTypeValue>
                                    </div>

                                  </div>

                                </div>
                              </div>
                              <div class="row">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">

                                  <div class="row">
                                    <div class="col-md-4 text-align-right">
                                      <label for="diaplayName" class="margin-bottom-0px margin-top-5px">UOM</label>
                                    </div>

                                    <div class="col-md-5">
                                      <input type="text" class="form-control" placeholder="UOM"
                                             id="PurchaseOrderItem.UomName"
                                             [(ngModel)]="PurchaseOrderItem.UomName"
                                             name="PurchaseOrderItem.UomName"
                                             maxlength="30" pattern="^[\0-9,._\-?]*$">

                                    </div>
                                  </div>


                                </div>
                              </div>

                              <!--<div class="row">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">

                                  <div class="row">
                                    <div class="col-md-4 text-align-right">
                                      <label for="diaplayName" class="margin-bottom-0px margin-top-5px">Sale Price</label>
                                    </div>

                                    <div class="col-md-5">
                                      <input type="text" class="form-control" placeholder="Sale Price"
                                             id="PurchaseOrderItem.SalePrice"
                                             [(ngModel)]="PurchaseOrderItem.SalePrice"
                                             name="PurchaseOrderItem.SalePrice"
                                             maxlength="30" pattern="^[\0-9,._\-?]*$">
                                    </div>
                                  </div>


                                </div>
                              </div>-->

                            </div>
                            <div class="col-md-6">

                              <div class="row">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                  <div class="row">
                                    <div class="col-md-4 text-align-right padding-left-0px">
                                      <label for="firstName" class="margin-bottom-0px margin-top-5px">
                                        Order Qty
                                      </label>
                                    </div>
                                    <div class="col-md-5">
                                      <input type="number"
                                             class="form-control background-lightblue font-size-16px font-weight-bold"
                                             placeholder="Order Qty"
                                             id="PurchaseOrderItem.Quantity"
                                             [(ngModel)]="PurchaseOrderItem.Quantity"
                                             name="PurchaseOrderItem.Quantity" #Quantity="ngModel"
                                             maxlength="30" #Oq="ngModel" pattern="^[1-9]\d*$">

                                      <small class="form-text text-danger"
                                             *ngIf="(!Quantity.valid && Quantity.errors.pattern)">(only positive numbers are allowed)</small>

                                    </div>

                                  </div>

                                </div>
                              </div>
                              <div class="row">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">

                                  <div class="row">
                                    <div class="col-md-4 text-align-right">
                                      <label for="diaplayName" class="margin-bottom-0px margin-top-5px">Bonus Qty</label>
                                    </div>

                                    <div class="col-md-5">
                                      <input type="number"
                                             class="form-control background-lightblue font-size-16px font-weight-bold"
                                             placeholder="Bonus Qty"
                                             id="PurchaseOrderItem.BonusQuantity"
                                             [(ngModel)]="PurchaseOrderItem.BonusQuantity"
                                             name="PurchaseOrderItem.BonusQuantity" #BonusQuantity="ngModel"
                                             maxlength="30" #Bq="ngModel" pattern="^[\0-9,._\-?]*$">
                                      <small class="form-text text-danger"
                                             *ngIf="(!BonusQuantity.valid && BonusQuantity.errors.pattern)">(only positive numbers are allowed)</small>
                                    </div>
                                  </div>


                                </div>
                              </div>

                              <div class="row">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">

                                  <div class="row">
                                    <div class="col-md-4 text-align-right">
                                      <label for="diaplayName" class="margin-bottom-0px margin-top-5px">Total Quantity</label>
                                    </div>

                                    <div class="col-md-5">
                                      <!--<input type="text" class="form-control" placeholder="Total Qty"
                 id="PurchaseOrderItem.TotalOrderQuantity"
                 [(ngModel)]="PurchaseOrderItem.TotalOrderQuantity"
                 name="PurchaseOrderItem.TotalOrderQuantity"
                 maxlength="30" #Tq="ngModel" pattern="^[\0-9,._\-?]*$">-->
                                      <label class="margin-bottom-0px form-control bk-color-lightgray">{{PurchaseOrderItem.Quantity + PurchaseOrderItem.BonusQuantity}}</label>
                                    </div>
                                  </div>


                                </div>
                              </div>
                              <div class="row">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">

                                  <div class="row">
                                    <div class="col-md-4 text-align-right">
                                      <label for="diaplayName" class="margin-bottom-0px margin-top-5px">Purchase Price</label>
                                    </div>

                                    <div class="col-md-5">

                                      <input type="text"
                                             class="form-control background-lightblue font-size-16px font-weight-bold"
                                             placeholder="Purchase Price"
                                             id="PurchaseOrderItem.PurchasePrice"
                                             [(ngModel)]="PurchaseOrderItem.PurchasePrice"
                                             name="PurchaseOrderItem.PurchasePrice"
                                             maxlength="30" #Pp="ngModel" pattern="^[\0-9,._\-?]*$">
                                      <small class="form-text text-danger"
                                             *ngIf="(!Pp.valid && Pp.errors.pattern)">(only positive numbers are allowed)</small>
                                    </div>
                                  </div>


                                </div>
                              </div>
                              
                              <div class="row">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">

                                  <div class="row">
                                    <div class="col-md-4 text-align-right">
                                      <label for="diaplayName" class="margin-bottom-0px margin-top-5px">Units / Pack</label>
                                    </div>

                                    <div class="col-md-5">
                                      <input type="number"
                                             class="form-control background-pink font-size-16px font-weight-bold"
                                             placeholder="Units Per Pack"
                                             id="PurchaseOrderItem.Pack"
                                             [(ngModel)]="PurchaseOrderItem.Pack"
                                             name="PurchaseOrderItem.Pack"
                                             maxlength="30" #Pack="ngModel" pattern="^[\0-9,._\-?]*$">
                                      <small class="form-text text-danger"
                                             *ngIf="(!Pack.valid && Pack.errors.pattern)">(only positive numbers are allowed)</small>
                                    </div>
                                  </div>


                                </div>
                              </div>

                              <div class="row">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">

                                  <div class="row">
                                    <div class="col-md-4 text-align-right">
                                      <label for="diaplayName" class="margin-bottom-0px margin-top-5px">Unit Price</label>
                                    </div>

                                    <div class="col-md-5">
                                      <label class="margin-bottom-0px form-control bk-color-lightgray">
                                        {{(PurchaseOrderItem.PurchasePrice) / (PurchaseOrderItem.Quantity * PurchaseOrderItem.Pack) | number:'1.2-2'}}
                                      </label>
                                      <!--<input type="text" class="form-control" placeholder="Unit Price"
                                             id="PurchaseOrderItem.UnitPrice"
                                             [(ngModel)]="PurchaseOrderItem.UnitPrice"
                                             name="PurchaseOrderItem.UnitPrice"
                                             maxlength="30" #Up="ngModel" pattern="^[\0-9,._\-?]*$">-->
                                    </div>
                                  </div>


                                </div>
                              </div>
                              <div class="row">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">

                                  <div class="row">
                                    <div class="col-md-4 text-align-right">
                                      <label for="diaplayName" class="margin-bottom-0px margin-top-5px">MRP</label>
                                    </div>

                                    <div class="col-md-5">
                                      <input type="text"
                                             class="form-control background-pink font-size-16px font-weight-bold"
                                             placeholder="MRP"
                                             id="PurchaseOrderItem.Mrp"
                                             [(ngModel)]="PurchaseOrderItem.Mrp"
                                             name="PurchaseOrderItem.Mrp"
                                             maxlength="30" #MRP="ngModel" pattern="^[\0-9,._\-?]*$">
                                      <small class="form-text text-danger"
                                             *ngIf="(!MRP.valid && MRP.errors.pattern)">(only positive numbers are allowed)</small>
                                    </div>
                                  </div>


                                </div>
                              </div>
                            </div>
                          </div>

                        </div>
                      </div>

                    </div>
                  </div>

                </div>
                <div class="card-footer">
                  <button type="submit"
                          (click)="activeModal.close(PurchaseOrderItem)"
                          class="btn actions-btn-prime float-right font-size-13px">Save</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


